<template>
  <div class="modal fade" id="modal-mobile-application">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" style="text-align:center">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{$t('mobile.app_description')}}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="form-group">
              <div class="col-md-12 col-lg-12" style="margin-bottom: 15px">
                <label for="description">{{$t('mobile.app_id')}}</label>
                <input type="text" class="form-control" v-model="applicationData.code" :disabled="applicationData.id != 0">
              </div>
              <br />
              <div class="col-md-12 col-lg-12" style="margin-bottom: 15px">
                <label for="description">{{$t('mobile.app_name')}}</label>
                <input type="text" class="form-control" v-model="applicationData.name">
              </div>
              <div class="col-md-12 col-lg-12">
                <label for="mobile_os">{{$t('mobile.os')}}</label>
                <div class="form-group"  style="margin-bottom: 0">
                    <input type="checkbox" disabled checked="checked">
                    <label for="iOS">
                      iOS
                    </label>
                </div>
                <div class="form-group"  style="margin-bottom: 0">
                    <input type="checkbox" disabled checked="checked">
                    <label for="Android">
                      Android
                    </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!-- status button -->
          <lte-button
            id="status-private"
            :right_icon="'fa fa-lock'"
            type="button"
            class="btn btn-primary pull-right"
            @click="onSaveApplication"
          >&nbsp;{{$t('common.save')}}</lte-button> <!-- status button -->

          <!-- save answer button -->
          <lte-button
            type="button"
            class="btn btn-dark pull-left"
            @click="closeModal"
          >{{$t('common.close')}}</lte-button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
// import { mapGetters, mapActions } from "vuex";
import LTEButton from "./LTEButton.vue";

export default {
  name: 'lte-modal',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      applicationData: {
        id: 0,
        code: "",
        name: "",
        description: ""
      },
      osData: {
        android: {
            id: "",
            name: "android"
        },
        ios: {
            id: "",
            name: "ios"
        },
      },
      styleObject: {
        default : "modal-default",
        danger  : "modal-danger",
        info    : "modal-info",
        warning : "modal-warning",
        success : "modal-success"
      },
      iconObject: {
        danger  : "fa-ban",
        info    : "fa-info",
        warning : "fa-warning",
        success : "fa-check"
      }
    }
  },
  methods: {
    closeModal: function() {
      $("#modal-mobile-application").modal("hide");
    },
    onConfirm: function () {
      this.$emit('onConfirm')
    },
    getStyle: function(style) {
      let cls = this.styleObject[style];
      return {
        cls: cls
      }
    },
    onSaveApplication: function() {
        let data = {
            id: this.applicationData.id,
            code: this.applicationData.code,
            name: this.applicationData.name,
            description: this.applicationData.description,
            android: this.osData.android.name,
            ios: this.osData.ios.name,
        }
        this.$emit('onSaveApplication', data);
    }
  },

  watch: {
    item: function() {
      if (this.item != undefined) {
          this.applicationData.id = this.item.id;
          this.applicationData.name = this.item.name;
          this.applicationData.code = this.item.code;
      } else {
          this.applicationData.id = 0;
          this.applicationData.name = "";
          this.applicationData.code = "";
      }
    }
  },

  mounted() {
    // if (this.item != undefined) {
    //     this.applicationData.id = this.item.id;
    //     this.applicationData.name = this.item.name;
    //     this.applicationData.code = this.item.code;
    // } else {
    //     this.applicationData.id = 0;
    //     this.applicationData.name = "";
    //     this.applicationData.code = "";
    // }
  },

  components: {
    "lte-button": LTEButton
  }
}

</script>

<style lang="scss" scoped>
  .modal {
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/MobileApplicationModal.vue